import { Component, OnInit } from '@angular/core';
import { UserService, TranslationService, CongresosService } from '../../services/services.index';
import * as jspdf from 'jspdf';
import * as html2canvas from 'html2canvas';
import { Congreso } from '../../models/congreso.model';
import { Router } from '@angular/router';

declare function init_plugins();

@Component({
  selector: 'app-asistencia',
  templateUrl: './asistencia.component.html',
  styles: []
})
export class AsistenciaComponent implements OnInit {

  loading: boolean = false;
  congreso: Congreso;
  certificadosHabilitados: boolean = false;

  constructor(public _userService: UserService,
              public _translationService: TranslationService,
              public _congresosService: CongresosService,
              public router: Router) { }

  ngOnInit() {
    init_plugins();
    this.cargarCongreso();
  }

  cargarCongreso() {
    this.loading = true;
    this._congresosService.getCongresoActivo().subscribe(resp => {
      if (resp.length === 1) {
        this.congreso = resp[0];
        let today: number = new Date().getTime();
        if (today > this.congreso.fechaFinCongreso) {
          this.certificadosHabilitados = true;
        } else {
          this.certificadosHabilitados = false;
          let lang: string = this._translationService.lang;
          let tituloSwal: string;
          let mensajeSwal: string;
          if (lang === 'es') {
            tituloSwal = 'Certificados no habilitados';
            mensajeSwal = 'Los certificados seran habilitados una vez finalice el congreso.';
          } else {
            tituloSwal = 'Certificates not enabled';
            mensajeSwal = 'The certificates will be enabled once the congress ends.';
          }

          swal(tituloSwal, mensajeSwal, 'error');
          this.router.navigate(['/dashboard']);
        }
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
  }

  generarPdf() {
    let data = document.getElementById('contentToConvert');
    html2canvas(data).then(canvas => {
    // Few necessary setting options
    let imgWidth = 295;
    let pageHeight = 295;
    let imgHeight = canvas.height * imgWidth / canvas.width;
    let heightLeft = imgHeight;

    const contentDataURL = canvas.toDataURL('image/png');
    let pdf = new jspdf('l', 'mm', 'a4'); // A4 size page of PDF
    let position = 0;
    pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
    pdf.save('certificado-asistencia.pdf'); // Generated PDF
});
  }

}



// WEBPACK FOOTER //
// ./src/app/certificados/asistencia/asistencia.component.ts